export default function videoInit() {
    const selectors = {
        main: '.b-video',
        video: '.b-video__iframe',
        videoHolder: '.b-video__video',
        btnArea: '.b-video__button',
        btnHolder: '.b-video__main',
    };

    window.onYouTubeIframeAPIReady = () => {
        $(selectors.main).each((i, elem) => {
            if (!$(elem).hasClass('js-init')) return;

            init($(elem));
        })
    };

    function init($elem) {
        const elems = {
            $main: $elem,
            $video: $elem.find(selectors.video),
            $btnArea: $elem.find(selectors.btnArea),
            $btnHolder: $elem.find(selectors.btnHolder),
            $videoHolder: $elem.find(selectors.videoHolder)
        };

        const id = Math.random().toString(36).substring(3);
        elems.$video.attr('id', id);

        const player = new YT.Player(id, {
            videoId: elems.$video.data('video-id'),
        });

        elems.$main.data('player-api', player);

    }

    function pauseVideo(player) {
        player.pauseVideo();
    }
}
